import { Observable } from 'rxjs';

import {
  CoverageRulePricing,
  CreatePricingPayload,
  MovePricingAssignmentsPayload,
  MovePricingAssignmentsResult,
  NewPricingVersionPayload,
  NewQuoteParameterPayload,
  PricingDetail,
  PricingList,
  QuoteParameter,
  QuoteParameterList,
  UpdatePricingPayload,
} from '../../../interfaces/pricing.interface';
import { QuoteScheme } from '../../../interfaces/quote.interface';

/**
 * Único punto de acceso a Pricing (`/quotes/settings/pricing`), su asignación a reglas de
 * cobertura y los parámetros de la cotización. Clase abstracta: es el token de inyección.
 */
export abstract class PricingApiService {
  abstract list(scheme?: QuoteScheme): Observable<PricingList>;

  abstract get(id: number): Observable<PricingDetail>;

  /** Crea el pricing con su v1. */
  abstract create(body: CreatePricingPayload): Observable<PricingDetail>;

  /** Nombre, descripción o archivar; 409 si se archiva uno asignado. */
  abstract update(id: number, body: UpdatePricingPayload): Observable<PricingDetail>;

  /** Programa la versión siguiente; 409 si ya hay una programada. */
  abstract addVersion(id: number, body: NewPricingVersionPayload): Observable<PricingDetail>;

  /** Cancela la versión programada; 409 si ya está en vigor. */
  abstract cancelVersion(id: number, version: number, reason: string): Observable<PricingDetail>;

  /** Pasa todas sus coberturas a otro pricing; 409 si el destino ya tiene coberturas. */
  abstract moveAssignments(
    id: number,
    body: MovePricingAssignmentsPayload,
  ): Observable<MovePricingAssignmentsResult>;

  abstract assign(
    coverageId: number,
    scheme: QuoteScheme,
    pricingId: number,
    reason: string,
  ): Observable<CoverageRulePricing>;

  abstract unassign(coverageId: number, scheme: QuoteScheme, reason: string): Observable<unknown>;

  abstract listParameters(): Observable<QuoteParameterList>;

  /** Programa un parámetro; 409 si ya hay uno programado para esa clave y alcance. */
  abstract scheduleParameter(body: NewQuoteParameterPayload): Observable<QuoteParameter>;

  /** Cancela un parámetro programado; 409 si ya está en vigor. */
  abstract cancelParameter(id: number, reason: string): Observable<unknown>;
}
